import styled from "styled-components";
import materialUI from "../../../material-UI";
import colors from "../../../constants/color";

export const Container = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  border: 1px;
  margin-top: 1rem;
  background-color: #ffffff;
  box-shadow: rgba(17, 17, 26, 0.05) 0px 1px 0px,
    rgba(17, 17, 26, 0.1) 0px 0px -8px;
  p {
    color: #333333;
    font-family: "Inter";
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.125rem;
    letter-spacing: 0px;
    text-align: left;
  }
`;

export const Button = styled(materialUI.Button)`
  width: 100%;
  height: 43px;
  border-radius: 8px;
  border: 1px solid ${colors.Mediumgrey};
  .MuiCircularProgress-root {
    width: 20px !important;
    height: 20px !important;
    color: ${colors.white};
  }
`;
